<template>
	<div class="vstack gap-2" v-for="(data, index) in goals" v-bind:key="index">
		<CompanyCardMedium :company="data.company" :subtitle="`Meta: ${data.goal.name}`" />
		<div class="row g-5">
			<div v-for="(detail, index) in data.details" v-bind:key="index" :class="getClass(data.details.length, index)">
				<HomeGoalCard :detail="detail" :goal="data.goal" :exchange="data.exchange" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			goals: Array
		},
		setup() {
			const getClass = (length, index) => length === 1 || (length % 2 !== 0 && index === 0) ? 'col-12' : 'col-12 col-md-6';

			return { getClass };
		}
	}
</script>